import script from "./PodestView.vue?vue&type=script&setup=true&lang=js"
export * from "./PodestView.vue?vue&type=script&setup=true&lang=js"

import "./PodestView.vue?vue&type=style&index=0&id=3a25a743&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a25a743"]])

export default __exports__